import cx from 'classnames'
import pluralize from 'pluralize'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { frameTheatreAddress } from '../../common/util/helper'
import '../../style/compositions.less';
import LoaderIcon from '../../icons/loading.svg'
import KeyIcon from '../../icons/key.svg'
import RemoveIcon from '../../icons/remove.svg'

class CompositionTheatreItem extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: false
    }
  }

  showKDMInfo (theatre, kdmGenerationCompleted) {
    this.setState({isLoading: true})
    this.props.showKDMInfo(theatre, kdmGenerationCompleted).then(() => {
      this.setState({isLoading: false})
    }).catch(() => {
      this.setState({isLoading: false})
    })
  }

  render () {
    const {theatre, index, cplInfo, getTheatreKdmStatus, renderKDMStatusSummary, renderDCPStatus, showKdmValidity} = this.props
    const kdmStatus = {}
    const {kdmSummary, timezone} = theatre
    const {validFrom, validTill} = kdmSummary || {}
    const showValidity = showKdmValidity(kdmSummary)
    const isTheatreKdmBooking = cplInfo.isKdmBooking && kdmSummary
    const kdmGenerationCompleted = isTheatreKdmBooking
      ? getTheatreKdmStatus(theatre, kdmStatus)
      : false
    const theatreAddress = frameTheatreAddress(theatre)
    return (
      <div key={index}
        className={cx('composition-detail-card-overview theatre-border qw-font-size-small qw-line-height-small qw-color-text-body qw-mb-x-small', {'qw-pointer-none': this.state.isLoading})}>

        <div className='composition-details-theatre qw-pl-x-large'>
          <span style={{fontSize: 12, fontWeight: 600}}>{theatre.name}</span>
          {
            theatreAddress &&
            <span className='block qw-font-size-x-small qw-color-text-secondary-heading'>
            {theatreAddress}
            </span>
          }
          {
            isTheatreKdmBooking &&
            <span className='block qw-font-size-x-small qw-color-text-secondary-heading'>
              {pluralize(I18n.t('compositions.screen'), theatre.screenCount, true)}
            </span>
           }
        </div>

        {
          cplInfo.isDcpBooking ?
          <div className='composition-details-dcp qw-pl-x-small'>
            {renderDCPStatus(theatre)}
          </div>
          :
          <div style={{display: 'flex', marginBottom: 20, width: "37%"}}>
            <RemoveIcon className="qw-icon-small inline qw-align-middle qw-mr-xx-small"/>
            <p style={{color: "#C40A0A", fontSize: 12, fontWeight: 600, marginLeft: 5, paddingTop: 2}}>DCP Unavailable</p>
          </div>
         }
        {
          isTheatreKdmBooking ?
          <div className='composition-details-kdm kdm-summary qw-cursor-pointer qw-pl-x-small'
            onClick={() => this.showKDMInfo(theatre, kdmGenerationCompleted)}>
              {
                this.state.isLoading &&
                <span className='inline-block qw-align-middle qw-icon-x-small'>
                  <LoaderIcon className='qw-icon-x-small'/>
                </span>
              }
              <div style={{display: 'flex'}}>
                <KeyIcon className="qw-icon-small inline qw-align-middle qw-mr-xx-small"/>
                <div>
                {
                  renderKDMStatusSummary(kdmStatus, showValidity &&
                  {
                  validFrom,
                  validTill,
                  timezone,
                  isMultiple: !validFrom && !validTill
                  })
                }
                </div>
              </div>
            </div>
            :
            <div style={{display: 'flex', marginLeft: 4}}>
              <RemoveIcon className="qw-icon-small inline qw-align-middle qw-mr-xx-small"/>
              <p style={{color: "#C40A0A", fontSize: 12, fontWeight: 600, marginLeft: 2, paddingTop: 2}}>KDM Unavailable</p>
            </div>
         }
      </div>
    )
  }
}

export default CompositionTheatreItem



// WEBPACK FOOTER //
// ./src/app/components/compositions/CompositionTheatreItem.js